<fieldset v-if="showDimensions" class="tt-c-review-dimensions-fieldset">
  <template v-for="dimDef in dimensionDefinitions">
    <tt-rating-meter v-if="dimDef.type === 1"
      v-model="dimensionValues[dimDef.id]"
      :valueDefs="dimValDefs[dimDef.id]"
      :labelId="'tt-custom-dim-' + dimDef.id"
      :errorText="dimensionErrors[dimDef.id]"
      :label="dimDef.label"
      :required="dimDef.required">
    </tt-rating-meter>
    <tt-range-field v-if="dimDef.type === 2 && dimValDefs[dimDef.id].length > 2"
      v-model="dimensionValues[dimDef.id]"
      :labelId="'tt-custom-dim-' + dimDef.id + '-label'" 
      :errorText="dimensionErrors[dimDef.id]"
      :groupName="'custom-dim-' + dimDef.id"
      :label="dimDef.label"
      :required="dimDef.required"
      :showMiddleLabel="showRangeMiddle"
      :valueDefinitions="dimDef.valueDefinitions">
    </tt-range-field>
    <tt-check-group v-if="isCheckGroupDim(dimDef)"
      v-model="dimensionValues[dimDef.id]"
      :id="'tt-custom-dim-' + dimDef.id"
      :errorText="dimensionErrors[dimDef.id]"
      :label="dimDef.label"
      :groupName="'custom-dim-' + dimDef.id"
      :displayType="checkGroupDimDisplayType(dimDef)"
      :fields="dimValDefs[dimDef.id]"
      :required="dimDef.required">
    </tt-check-group>
    <tt-selectbox v-if="dimDef.type === 3 && dimValDefs[dimDef.id].length > 3"
      v-model="dimensionValues[dimDef.id]"
      :id="'tt-custom-dim-' + dimDef.id"
      :errorText="dimensionErrors[dimDef.id]"
      :label="dimDef.label"
      :name="'custom-dim-' + dimDef.id"
      :selectOneText="$msg('revForm.selectOne')"
      :options="dimValDefs[dimDef.id]"
      :required="dimDef.required"
      ></tt-selectbox>
  </template>
</fieldset>
